import React from 'react';
import { makeStyles, Theme, Typography, TypographyTypeMap } from '@material-ui/core';
import { OverridableComponent, OverrideProps } from '@material-ui/core/OverridableComponent';
import { typography, TypographyVariant, TypographyColor, typographyColorMap } from '../styles/typography';

const useStyles = makeStyles<Theme, { color?: string }>((theme: Theme) => ({
  root: {
    color: (props) => props.color
  }
}));

interface StyledTextTypeMap<
  P = {},
  D extends React.ElementType = TypographyTypeMap['defaultComponent']
> extends Omit<TypographyTypeMap<P, D>, 'props'> {
  props: P & Omit<TypographyTypeMap['props'], 'variant' | 'color'> & {
    variant?: TypographyVariant
    color?: TypographyColor
  }
}

type StyledTextProps<
  D extends React.ElementType = TypographyTypeMap['defaultComponent'],
  P = {}
> = OverrideProps<StyledTextTypeMap<P, D>, D>;

export const StyledText: OverridableComponent<StyledTextTypeMap> = ({
  variant = 'body1',
  color,
  style,
  children,
  ...restProps
}: StyledTextProps) => {
  const colorString = color ? typographyColorMap[color] : undefined;
  const classes = useStyles({ color: colorString });
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Typography style={{ ...typography[variant], ...style }} classes={classes} {...restProps}>
      {children}
    </Typography>
  );
};
